const Logo = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_112_774)">
        <path
          d="M2.27429 9.03991C2.27377 8.25211 2.42864 7.47195 2.73006 6.74409C3.03148 6.01624 3.47351 5.35499 4.03084 4.79821C4.58818 4.24143 5.24987 3.80006 5.97802 3.49938C6.70618 3.19869 7.4865 3.04459 8.27429 3.04591H16.2743C19.5873 3.04591 22.2743 5.74091 22.2743 9.03991V21.0459H8.27429C4.96129 21.0459 2.27429 18.3509 2.27429 15.0519V9.03991ZM14.2743 11.0459V13.0459H16.2743V11.0459H14.2743ZM8.27429 11.0459V13.0459H10.2743V11.0459H8.27429Z"
          fill="#0390fc"
        />
      </g>
      <defs>
        <clipPath id="clip0_112_774">
          <rect
            width="24"
            height="24"
            fill="#0390fc"
            transform="translate(0.274292 0.0458984)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
